import { CommonGet, CommonPost } from '../../helpers/HttpClient';

export default {
  getAllGroups,
  getFactoryByGroupID,
  GetSuppliersByItemIDAndFactoryID,
  GetPoDetailsforApproval,
  ApprovePurchaseOrders,
  GetPurchaseOrderDetails,
  GetQuotationBySupplierID
};

async function getAllGroups() {
  let response = await CommonGet('/api/Factory/GetAllActiveGroups', null);
  let groupArray = []
  for (let item of Object.entries(response.data)) {
    groupArray[item[1]["groupID"]] = item[1]["groupName"]
  }
  return groupArray;
}

async function getFactoryByGroupID(groupID) {
  var factoryArray = [];

  const response = await CommonGet('/api/Group/GetFactoryByGroupID', 'groupID=' + groupID)
  for (let item of Object.entries(response.data)) {
    factoryArray[item[1]["factoryID"]] = item[1]["factoryName"]
  }
  return factoryArray;
}

async function GetSuppliersByItemIDAndFactoryID(groupID, factoryID) {
  var supplierArray = [];
  const response = await CommonGet('/api/PurchaseOrderNew/GetSuppliersByGroup', "groupID=" + parseInt(groupID) + "&factoryID=" + parseInt(factoryID));
  for (let item of Object.entries(response.data)) {
    supplierArray[item[1]["supplierID"]] = item[1]["supplierName"];
  }
  return supplierArray;
}

async function GetQuotationBySupplierID(supplierID) {
  let response = await CommonGet('/api/PurchaseOrderNew/GetQuotationBySupplierID', "supplierID=" + parseInt(supplierID));
  let quotationNumbersArray = [];
  for (let item of Object.entries(response.data)) {
    quotationNumbersArray[item[1]["quotationHeaderID"]] = item[1]["quotationNumber"];
  }
  return quotationNumbersArray;
};

async function GetPoDetailsforApproval(groupID, factoryID, status) {
  const response = await CommonGet('/api/PurchaseOrderNew/GetPoDetailsforApproval', 'groupID=' + parseInt(groupID) + '&factoryID=' + parseInt(factoryID) + '&status=' + parseInt(status));
  return response;
}

async function ApprovePurchaseOrders(model) {
  const response = await CommonPost('/api/PurchaseOrderNew/ApprovePurchaseOrders', null, model);

  return response;
}

async function GetPurchaseOrderDetails(purchaseOrderID, groupID, factoryID) {
  const response = await CommonGet('/api/PurchaseOrderNew/GetPurchaseOrderDetailsForApproval', "purchaseOrderID=" + purchaseOrderID.toString() +
    "&groupID=" + parseInt(groupID) + "&factoryID=" + parseInt(factoryID));
  return response.data;
}